<template>
  <div @click="()=>{}" @touchstart="()=>{}" id="app">
    <!-- <div class="fc">
      <div
        @click="cleanAccessToken"
      >退出登录测试999</div>
      <div  @click="goCouponList">跳转抵用券中心</div>
    </div>-->
    <!-- <div class="breakAll">{{hash}}</div> -->
    <!-- 容器 -->
    <div :class="{blur:isBlur, 'scale-iphoneX-container': showSafeDistance()}" class="wrapper-con">
      <!-- <transition name="fade" mode="out-in"> -->
      <keep-alive include="rfFair">
        <router-view v-wechat-title="$route.meta.title"></router-view>
      </keep-alive>
      <!-- </transition> -->

      <!-- 左下角订单列表&&购物车入口 -->
      <div :class="positionSetting()" class="posi-fix" v-if="showPosi() && showLeftBottomBtn">
        <div class="float-icon">
          <div class="img-div">
            <span @click="goOrders" class="order-list-icon"></span>
          </div>
          <div @click="goCart" class="img-div">
            <img src="./assets/images/cart_new.png" />
            <span :class="{'cart-0': cartNum === 0, 'cart-1': cartNum > 0 && cartNum < 10, 'cart-2': cartNum > 9}">{{cartNum || ''}}</span>
          </div>
        </div>
      </div>
    </div>

    <dialog-detail key="detail" v-if="$store.state.userInfo.currentProduct"></dialog-detail>
    <dialogShareDirect></dialogShareDirect>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import dialogDetail from './components/dialog_detail'
import dialogShareDirect from '@/components/dialog_share_direct'
import keyId from './mixin/keyId'
export default {
  name: 'app',
  mixins: [keyId],
  data () {
    return {
      isShowView: true,
      isMiniprogram: window.__wxjs_environment === 'miniprogram'
    }
  },
  computed: {
    ...mapState({
      isApp: state => state.sdk.isApp,
      isWeChat: state => state.browser.versions.weChat,
      isIos: state => state.browser.versions.ios
    }),
    isH5 () {
      return !this.isApp && !this.isWeChat && !this.isMiniprogram
    },
    showLeftBottomBtn () {
      return this.$store.state.showLeftBottomBtn
    },
    hash () {
      return location.href
    },
    cartNum () {
      return this.$store.state.cartNum
    },
    isBlur () {
      let flag = false
      let visibleArr = Object.values(this.$store.state.dialogVisible)
      for (let i in visibleArr) {
        if (visibleArr[i]) {
          flag = true
          break
        }
      }
      return flag
    },
    isFooterVisible () {
      return this.$route.meta.showBottom === true
    },
    templeteName () {
      return this.$store.state.serviceInfo.templeteName
    }
  },
  methods: {
    // goCouponList () {
    //   this.$router.push({ name: 'centerListCoupon', query: this.$route.query })
    // },
    positionSetting () {
      let tempArr = ['home', 'rfFair', 'rfActivity', 'rfStation']
      const isSetting = tempArr.some(item => (
        item === this.$route.name
      ))
      let className = isSetting ? 'positionUp' : ''
      return className
    },
    showPosi () {
      // let ignoreList = ['personalOrderListCoupon', 'applyShopList', 'confirmOrderCoupon', 'purchaseDetailCoupon', 'orderDetailCoupon', 'centerListCoupon', 'paySuccess', 'goodsDetail', 'error', 'allShopCart', 'allShopCartAppUse', 'confirmOrder', 'confirmOrderAppUse', 'orderDetail', 'personalCenter', 'personalCenterAppUse', 'login', 'orderQRCodeDetail', 'orderQRCodeDetail-allinpay', 'pickCoupon',
      //   'quickPay', 'pickCouponQuick', 'quickOrderDetail', 'receiptAddress', 'editAddress', 'afterSales', 'refundDetail', 'optimizingDetail', 'evaluateList', 'evaluateForm', 'cityList', 'communityList', 'groupList', 'groupDetail', 'offlinePayment', 'toolRental', 'rfStation', 'confirmPay', 'downloadApp', 'storeDetailPromo', 'goodsDetailPromo'
      // ]
      let showList = ['home']
      const show = showList.some(item => {
        return item === this.$route.name
      })
      // console.log('isShow', isShow)
      return show
    },
    showSafeDistance () {
      let tempArr = ['goodsDetail', 'confirmOrder', 'orderDetail', 'receiptAddress', 'editAddress']
      const isShow = tempArr.some(item => {
        return item === this.$route.name
      })
      return isShow
    },
    goOrders () {
      if (!this.$getAccessTokenFromStorage()) {
        localStorage.setItem('goPersonalCenter', '1')
        let redirectUrl = window.location.href
        this.$store.dispatch('GO_TO_LOGIN_NOT_APP', redirectUrl)
        if (window.__wxjs_environment === 'miniprogram') {
          return
        }
      }
      let params = {}
      params.accessToken = this.$getAccessTokenFromStorage()
      this.$store.dispatch('validateToken', { params }).then(data => {
        this.$router.push({ name: 'personalCenter', query: this.$route.query })
      }).catch(message => {
        console.log(message)
      })
    },
    goCart () {
      if (!this.$getAccessTokenFromStorage()) {
        localStorage.setItem('goAllShopCart', '1')
        let redirectUrl = window.location.href
        this.$store.dispatch('GO_TO_LOGIN_NOT_APP', redirectUrl)
        if (window.__wxjs_environment === 'miniprogram') {
          return
        }
      }
      let params = {}
      params.accessToken = this.$getAccessTokenFromStorage()
      this.$store.dispatch('validateToken', { params }).then(data => {
        this.$router.push({ name: 'allShopCart', query: this.$route.query })
      }).catch(message => {
        console.log(message)
      })
    },
    cleanAccessToken () {
      this.$store.dispatch('LOGOUT')
    }
  },
  created () {
    // this.$toast({duration: -1,iconClass: 'icon icon-success',message:`您已拼团成功！我们将在活动结束后7日发起蓝莓派送`})
    // let $vm = this
    // 调试
    // setTimeout(function () {
    //   $vm.$indicator.open()
    // }, 2000)
    // this.$router.replace({ name: 'register', query: this.$query })
  },
  mounted () {
    try {
      var el = document.getElementById('static-loading')
      el.parentNode.removeChild(el)
    } catch (e) {
      // 调试
      // console.error(e);
    }
  },
  components: {
    dialogDetail,
    dialogShareDirect
  }
}
</script>

<style lang="less">
@import './assets/less/base.less';
@import './assets/less/function_px.less';
@import './assets/less/style.less';
.blur {
  filter: blur(10px);
}
.breakAll {
  position: fixed;
  top: 10px;
  left: 10px;
  word-break: break-all;
  z-index: 99999;
  background-color: aqua;
}
.wrapper-con {
  flex: 1 0 auto;
  margin: 0;
  display: flex;
  flex-direction: column;
  // .scale-iphoneX-fixed;
}
.fc {
  position: fixed;
  display: flex;
  justify-content: space-between;
  width: 100%;
  top: 0px;
  color: black;
  z-index: 999;
  div {
    background-color: white;
  }
}
.positionUp {
  bottom: 63px;
  @media only screen and (-webkit-device-pixel-ratio: 2) {
    @dpr: 2;
    bottom: calc(~'env(safe-area-inset-bottom) * @{dpr} + 63px');
  }
  @media only screen and (-webkit-device-pixel-ratio: 3) {
    @dpr: 3;
    bottom: calc(~'env(safe-area-inset-bottom) * @{dpr} + 63px');
  }
}
</style>
